import React, { useState } from 'react';
import * as Yup from 'yup';
import { Link } from 'react-router-dom';
import { yupResolver } from '@hookform/resolvers/yup';
import { useForm } from 'react-hook-form';
import { CloseEyeIcon, OpenEyeIcon } from '../../components/icons/IconProvider';

import { AccountSettingsService, Spinner, Alert } from '../../services';
import AuthHeaderTextComponent from '../../components/auth/AuthHeaderTextComponent';
import FormInput from '../../components/FormInput';

const schema = Yup.object({
  oldPassword: Yup.string().required('Old Password is required'),
  newPassword: Yup.string()
    .required('New Password is required')
    .matches(
      /^(?=.*[A-Z])(?=.*[a-z])(?=.*\d)(?=.*[-’/`~!#*$@_%+=.,^&(){}[\]|;:”<>?\\])[A-Za-z\d@$!%*#?&-’/`~!#*$@_%+=.,^&(){}[\]|;:”<>?\\]{8,}$/,
      'Your password must contain at least one uppercase, one lowercase, one digit and a special character. 8 characters minimum',
    ),
  confirmPassword: Yup.string()
    .required('Confirm Password is required')
    .oneOf(
      [Yup.ref('newPassword'), null],
      'Password and Confirm Password should be the same',
    ),
}).required();

const ChangePassword = () => {
  const {
    register,
    handleSubmit,
    formState: { errors },
    reset,
  } = useForm({
    resolver: yupResolver(schema),
  });

  const [currentPasswordShown, setCurrentPasswordShown] = useState(false);
  const [passwordShown, setPasswordShown] = useState(false);
  const [confirmPasswordShown, setConfirmPasswordShown] = useState(false);

  const onSubmit = (data) => {
    onChangePassword(data);
  };

  const onChangePassword = async (_passwordFormInput) => {
    Spinner.show();

    try {
      const passwordData = {
        old_password: _passwordFormInput.oldPassword,
        new_password: _passwordFormInput.newPassword,
        confirm_password: _passwordFormInput.confirmPassword,
      };

      const response =
        await AccountSettingsService.changePassword(passwordData);

      Spinner.hide();
      reset();
      if (response.status === 'failure') {
        Alert.error(response.message);
        return false;
      }
      Alert.success(response.message);
    } catch (error) {
      Spinner.hide();
      Alert.error(error.message);
    }
  };

  const togglePasswordVisiblity = (_type) => {
    if (_type == 'currentPassword') {
      setCurrentPasswordShown(currentPasswordShown ? false : true);
    } else if (_type == 'password') {
      setPasswordShown(passwordShown ? false : true);
    } else {
      setConfirmPasswordShown(confirmPasswordShown ? false : true);
    }
  };

  return (
    <div className="">
      <div className="flex items-center justify-center min-h-[calc(100vh-140px)]">
        <div className="w-full md:max-w-4xl bg-gray-100 border border-gray-100 rounded-md md:m-6">
          <div className="grid grid-cols-1 md:grid-cols-2 md:items-center">
            <div className="md:border-r md:border-[#dcdee2] flex justify-center items-center flex-col h-full md:px-6 md:pt-10 p-4 pb-0 md:pb-10">
              <div className="hidden md:block">
                <img
                  src="/img/changepasswordimgnew.png"
                  alt=""
                  className="max-w-[280px]"
                />
              </div>
              <div className="md:mt-12">
                <h4 className="mb-3 mt-4 text-center md:text-4xl">
                  Change Password
                </h4>
                <p className="mb-5 text-sm text-[#85919F] text-center">
                  Create new password for further transactions
                </p>
              </div>
            </div>
            <div className="md:px-6 md:py-10 p-5">
              <div className="md:mb-12 mb-4">
                <AuthHeaderTextComponent title={''} desc={''} />
              </div>
              <form onSubmit={handleSubmit(onSubmit)}>
                <div className="relative">
                  <FormInput
                    name="oldPassword"
                    type={currentPasswordShown ? 'text' : 'password'}
                    placeholder="Old Password"
                    register={register}
                    errors={errors}
                    className="mb-2 mt-2"
                    autoComplete="off"
                    labelClassName="font-semibold"
                  />

                  <Link
                    to=""
                    onClick={() => togglePasswordVisiblity('currentPassword')}
                    className="changepassword-password-text"
                  >
                    {currentPasswordShown ? <OpenEyeIcon /> : <CloseEyeIcon />}
                  </Link>
                </div>

                <div className="relative">
                  <FormInput
                    name="newPassword"
                    type={passwordShown ? 'text' : 'password'}
                    placeholder="New Password"
                    register={register}
                    errors={errors}
                    className="mb-2 mt-2"
                    autoComplete="off"
                    labelClassName="font-semibold"
                  />
                  <Link
                    to=""
                    onClick={() => togglePasswordVisiblity('password')}
                    className="changepassword-password-text"
                  >
                    {passwordShown ? <OpenEyeIcon /> : <CloseEyeIcon />}
                  </Link>
                </div>

                <div className="relative">
                  <FormInput
                    name="confirmPassword"
                    type={confirmPasswordShown ? 'text' : 'password'}
                    placeholder="Confirm New Password"
                    register={register}
                    errors={errors}
                    className="mb-2 mt-2"
                    autoComplete="off"
                    labelClassName="font-semibold"
                  />
                  <Link
                    to=""
                    onClick={() => togglePasswordVisiblity('confirmPassword')}
                    className="changepassword-password-text"
                  >
                    {confirmPasswordShown ? <OpenEyeIcon /> : <CloseEyeIcon />}
                  </Link>
                </div>

                <div className="mt-4">
                  <button
                    type="submit"
                    className="w-full bg-GreenColor text-sm font-medium"
                  >
                    Change Password
                  </button>
                </div>
              </form>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};
export default ChangePassword;
